import { Address } from 'viem';

import { CHAIN_ID, ZERO_ADDRESS } from '@constants/common/chain.constants';

import { Token } from '@app-types/common/token.types';

export enum TokenSymbol {
  BNB = 'BNB',
  EMP = 'EMP',
  ESHARE = 'eSHARE',
  WBNB = 'WBNB',
  FTM = 'FTM',
  ETH = 'ETH',
  AVAX = 'AVAX',
  PLS = 'PLS',
  USDC = 'USDC',
  USDT = 'USDT',
  USDEX_PLUS = 'USDEX+',
  WAVAX = 'WAVAX',
  DAI = 'DAI',
  OP = 'OP',
  GDEX = 'GDEX',
  USDC_E = 'USDC_E',
  ES_USDEX = 'esUSDEX',
  ES_USDEX_EMP = 'esUSDEXBond',
  USDEX = 'USDEX',
  BTCB = 'BTCB',
  DEXSHARE = 'DEXSHARE',
  ADA = 'ADA',
  ATOM = 'ATOM',
  LINK = 'LINK',
  NEAR = 'NEAR',
  XRP = 'XRP',
  LTC = 'LTC',
  FIL = 'FIL',
  MASK = 'MASK',
  DEX = 'DEX',
  MATIC = 'MATIC',
  BUSD = 'BUSD',
  MDB = 'MDB',
  MDB_PLUS = 'MDB+',
  CANTO = 'CANTO',
  WCANTO = 'WCANTO',
  NOTE = 'NOTE',
  ORN = 'ORN',
  WFTM = 'WFTM',
  BTC = 'BTC',
  CRV = 'CRV',
  MIM = 'MIM',
  BOO = 'BOO',
  STG = 'STG',
  EQUAL = 'EQUAL',
  THE = 'THE',
  WETH = 'WETH',
  VELO = 'VELO',
  WBTC = 'WBTC',
  ARB = 'ARB',
  ARX = 'ARX',
  FLOW = 'FLOW',
  KSWAP = 'KSWAP',
  GLCR = 'GLCR',
  USDT_E = 'USDT.E',
  WETH_E = 'WETH.E',
  FOXIFY = 'FOXIFY',
  VEGLACIER = 'VEGLACIER',
  L1X = 'L1X',
  AETH = 'AETH',
  VEFLOW_NFT = 'VEFLOW NFT',
  DEXMAXIETF = 'DEXMAXIETF',
  DEXETFTOTALS = 'DEXETF TOTALS',
  VAULT_INVESTMENTS = 'VAULT INVESTMENTS',
  DEXIRA = 'DEXIRA',
  S = 'S',
  MT = 'MT',
}

export const NATIVE_TOKEN: Record<number, Token> = {
  [CHAIN_ID.BSC]: new Token(
    CHAIN_ID.BSC,
    ZERO_ADDRESS,
    18,
    TokenSymbol.BNB,
    false,
    TokenSymbol.BNB,
  ),
  [CHAIN_ID.OPTIMISM]: new Token(
    CHAIN_ID.OPTIMISM,
    ZERO_ADDRESS,
    18,
    TokenSymbol.ETH,
    false,
    TokenSymbol.ETH,
  ),
  [CHAIN_ID.ARBITRUM]: new Token(
    CHAIN_ID.ARBITRUM,
    ZERO_ADDRESS,
    18,
    TokenSymbol.ETH,
    false,
    TokenSymbol.ETH,
  ),
  [CHAIN_ID.AVALANCHE]: new Token(
    CHAIN_ID.AVALANCHE,
    ZERO_ADDRESS,
    18,
    TokenSymbol.AVAX,
    false,
    TokenSymbol.AVAX,
  ),
  [CHAIN_ID.BASE]: new Token(
    CHAIN_ID.BASE,
    ZERO_ADDRESS,
    18,
    TokenSymbol.ETH,
    false,
    TokenSymbol.ETH,
  ),
  [CHAIN_ID.PULSE]: new Token(
    CHAIN_ID.PULSE,
    ZERO_ADDRESS,
    18,
    TokenSymbol.PLS,
    false,
    TokenSymbol.PLS,
  ),
  [CHAIN_ID.MANTA]: new Token(
    CHAIN_ID.MANTA,
    ZERO_ADDRESS,
    18,
    TokenSymbol.ETH,
    false,
    TokenSymbol.ETH,
  ),
  [CHAIN_ID.SONIC]: new Token(
    CHAIN_ID.SONIC,
    ZERO_ADDRESS,
    18,
    TokenSymbol.S,
    false,
    TokenSymbol.S,
  ),
};

export const TOKENS = {
  [CHAIN_ID.BSC]: {
    [TokenSymbol.BNB]: NATIVE_TOKEN[CHAIN_ID.BSC],
    [TokenSymbol.EMP]: new Token(
      CHAIN_ID.BSC,
      '0x3b248CEfA87F836a4e6f6d6c9b42991b88Dc1d58',
      18,
      TokenSymbol.EMP,
      false,
      'EMP',
    ),
    [TokenSymbol.ESHARE]: new Token(
      CHAIN_ID.BSC,
      '0x29C55f1b02A95F0B30e61976835a3eee2359ad92',
      18,
      TokenSymbol.ESHARE,
      true,
      'ESHARE V2',
    ),
    [TokenSymbol.WBNB]: new Token(
      CHAIN_ID.BSC,
      '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      18,
      TokenSymbol.WBNB,
      false,
      'WBNB',
    ),
  },
  [CHAIN_ID.OPTIMISM]: {
    [TokenSymbol.ETH]: NATIVE_TOKEN[CHAIN_ID.OPTIMISM],
  },
  [CHAIN_ID.ARBITRUM]: {
    [TokenSymbol.ETH]: NATIVE_TOKEN[CHAIN_ID.ARBITRUM],
    [TokenSymbol.USDC]: new Token(
      CHAIN_ID.ARBITRUM,
      '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
      6,
      TokenSymbol.USDC,
    ),
    [TokenSymbol.GDEX]: new Token(
      CHAIN_ID.ARBITRUM,
      '0x92a212d9F5eEf0b262aC7D84AEA64a0d0758B94f',
      18,
      TokenSymbol.GDEX,
    ),
    [TokenSymbol.USDC_E]: new Token(
      CHAIN_ID.ARBITRUM,
      '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
      6,
      // TODO: fix?
      TokenSymbol.USDC_E,
    ),
    [TokenSymbol.USDEX_PLUS]: new Token(
      CHAIN_ID.ARBITRUM,
      '0x4117EC0A779448872d3820f37bA2060Ae0B7C34B',
      18,
      TokenSymbol.USDEX_PLUS,
    ),
    [TokenSymbol.ES_USDEX]: new Token(
      CHAIN_ID.ARBITRUM,
      '0x0579d2862264076f06cD191D74F4aBd5fb95Ef82',
      18,
      TokenSymbol.ES_USDEX,
    ),
  },
  [CHAIN_ID.AVALANCHE]: {
    [TokenSymbol.AVAX]: NATIVE_TOKEN[CHAIN_ID.AVALANCHE],
  },
  [CHAIN_ID.BASE]: {
    [TokenSymbol.ETH]: NATIVE_TOKEN[CHAIN_ID.BASE],
    [TokenSymbol.WETH]: new Token(
      CHAIN_ID.BASE,
      '0x4200000000000000000000000000000000000006',
      18,
      TokenSymbol.WETH,
      false,
      TokenSymbol.WETH,
    ),
    [TokenSymbol.GDEX]: new Token(
      CHAIN_ID.BASE,
      '0x53Cb59D32a8d08fC6D3f81454f150946A028A44d',
      18,
      TokenSymbol.GDEX,
      false,
      'DexFi Governance',
    ),
    [TokenSymbol.MT]: new Token(
      CHAIN_ID.BASE,
      '0x5d9a960d534d327325656f2e1b0592c62b376293',
      18,
      TokenSymbol.MT,
      false,
      'MockToken',
    ),
    [TokenSymbol.USDC]: new Token(
      CHAIN_ID.BASE,
      '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
      6,
      TokenSymbol.USDC,
      false,
      'USD Coin ',
    ),
    [TokenSymbol.ES_USDEX]: new Token(
      CHAIN_ID.BASE,
      '0x378e5c17f4ce0De37220886Ac627f3016eA63272',
      18,
      TokenSymbol.ES_USDEX,
      false,
      TokenSymbol.ES_USDEX,
    ),
    [TokenSymbol.ES_USDEX_EMP]: new Token(
      CHAIN_ID.BASE,
      '0xA49a9333e41aC6c824ef6c1b9f8A176E99f83BC7',
      18,
      TokenSymbol.ES_USDEX,
      false,
      TokenSymbol.ES_USDEX,
    ),
  },
  [CHAIN_ID.PULSE]: {
    [TokenSymbol.PLS]: NATIVE_TOKEN[CHAIN_ID.PULSE],
    [TokenSymbol.USDEX_PLUS]: new Token(
      CHAIN_ID.PULSE,
      '0xaA2C47a35C1298795B5271490971Ec4874C8e53d',
      18,
      TokenSymbol.USDEX_PLUS,
    ),
  },
  [CHAIN_ID.MANTA]: {
    [TokenSymbol.ETH]: NATIVE_TOKEN[CHAIN_ID.MANTA],
  },
  [CHAIN_ID.SONIC]: {
    [TokenSymbol.S]: NATIVE_TOKEN[CHAIN_ID.SONIC],
  },
};

export const MAX_UINT256 = BigInt(
  '115792089237316195423570985008687907853269984665640564039457584007913129639935',
);

export enum AssetType {
  Zapper = 'zapper',
  Lp = 'lp',
  Nft = 'nft',
  Emergency = 'emergency',
}

export const PATH_TO_STABLE: Record<string, readonly Address[]> = {
  [TOKENS[CHAIN_ID.ARBITRUM][TokenSymbol.GDEX].address]: [
    TOKENS[CHAIN_ID.ARBITRUM][TokenSymbol.GDEX].address,
    TOKENS[CHAIN_ID.ARBITRUM][TokenSymbol.USDEX_PLUS].address,
    TOKENS[CHAIN_ID.ARBITRUM][TokenSymbol.USDC_E].address,
  ] as Address[],
  [TOKENS[CHAIN_ID.ARBITRUM][TokenSymbol.USDEX_PLUS].address]: [
    TOKENS[CHAIN_ID.ARBITRUM][TokenSymbol.USDEX_PLUS].address,
    TOKENS[CHAIN_ID.ARBITRUM][TokenSymbol.USDC_E].address,
  ] as Address[],
};

export const DEFAULT_STABLE_DECIMALS = 6;

export enum TokenPair {
  GDEX_ETH = 'GDEX_ETH',
  USDC_ETH = 'USDC_ETH',
}

export const UNIV3_POOLS: Partial<
  Record<CHAIN_ID, Record<TokenPair, Address>>
> = {
  [CHAIN_ID.BASE]: {
    [TokenPair.GDEX_ETH]: '0x65B6ee9CaC744D4eed9886406EAD6bc4E5681068',
    [TokenPair.USDC_ETH]: '0xd0b53d9277642d899df5c87a3966a349a798f224',
  },
};
